module.exports = __webpack_public_path__ + "static/img/Geos-2022-Angelica.8288a9f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Geos-2022-Angelica.png
// module id = NLFb
// module chunks = 0